import { useUtils } from "@/app/hooks/useUtils";

const BillingMirrorHeader = ({clinicName}) => {
  const {veticDateFormat} = useUtils();
  const weekday = new Date().toLocaleDateString("en-IN", {
    weekday: "long",
  });

  return (
    <div className="w-full flex flex-wrap justify-between items-center gap-3 pl-14 pr-14 font-roboto">
      <div className="flex flex-col gap-1 sm:gap-1">
        <img
          src="/vetic_logo.svg"
          alt="Billing Mirror Icon"
          className="w-[95px] sm:w-[113px] h-auto"
        />
        <p className="pl-[6px] sm:pl-[7px] text-[13px] sm:text-[16px]">
         {clinicName}
        </p>
      </div>
      <p className="text-[13px] sm:text-[16px] text-right w-full sm:w-auto">
        {veticDateFormat(new Date().toDateString())}, {weekday}
      </p>
    </div>
  );
};

export default BillingMirrorHeader;


